export default "<b>Trygghet</b> med att ha full koll på vad som ska göras och som gjorts, spårbarhet in i minsta detalj och full transparens. ";